(function() {
    module.exports = {
        nextChap : nextChap,
        prevChap : prevChap,
    }



    function nextChap() {
        if($(".chapter-meta-container.active").next().attr("data-chapter")=="4") {
            $("#next-chapter-btn").fadeOut();
        } else {
            $("#prev-chapter-btn").fadeIn();
        }
        $(".chapter-teaser").fadeOut(function() {
            $(this).css("background-image", "url('./media/TCphotos/"+$(".chapter-meta-container.active").attr("data-background")+".jpg')").fadeIn();
        });
        $(".chapter-meta-container.active").removeClass("slide-back-in slide-back-out").toggleClass("slide-in slide-out active").next().removeClass("slide-back-in slide-back-out").toggleClass("slide-in active");
    }

    function prevChap() {
        if($(".chapter-meta-container.active").prev().attr("data-chapter")=="1") {
            $("#prev-chapter-btn").fadeOut();
        } else {
            $("#next-chapter-btn").fadeIn();
        }
        $(".chapter-teaser").fadeOut(function() {
            $(this).css("background-image", "url('./media/TCphotos/"+$(".chapter-meta-container.active").attr("data-background")+".jpg')").fadeIn();
        });
        $(".chapter-meta-container.active").removeClass("slide-in slide-out").toggleClass("slide-back-in slide-back-out active").prev().removeClass("slide-in slide-out").toggleClass("slide-back-in active");
    }
})();